import { Injectable } from '@angular/core';
import { Socket, io } from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
import { SharedService } from './shared.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  public socket: Socket;
  public store: any = {
    participants: {},
  };
  public shareObject: any = {
    messages: [],
    chatRooms: [],
    room: null,
  };
  constructor(
    private sharedService: SharedService,
    private translate: TranslateService
  ) {
    this.socket = io(new URL(this.sharedService.env.apiUrl).origin, {
      auth: { token: this.sharedService.token, },
      transports: ['websocket', 'polling'],
    });
    this.socket.on('chat.new-message', (message: any) => {
      message.user = this.getParticipant(message.user);
      message.createdAt = new Date(message.createdAt).getTime();
      message.content = this.handleContent(message.content);
      if (this.shareObject.outgoing || !this.store.currentRoom || message.room !== this.store.currentRoom.id) {
        console.log('new-message', message);
        this.sharedService.toast({
          title: this.translate.instant(`chat_notify_new_message`) + ': ' + message.user.profile.name,
          message: message.content,
          type: 'success',
          link: `/user/chat/${message.room}`,
        })
      }
    });
    // setInterval(() => {
    //   console.log(`this.store.participants`, this.store.participants)
    // }, 1000);
  }
  connect(): void {
    if (!this.socket.connected) {
      this.socket.connect();
    }
  }
  disconnect(): void {
    if (this.socket.connected) {
      this.socket.disconnect();
    }
  }
  listenForMessages(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('chat.new-message', (message: any) => {
        message.user = this.getParticipant(message.user);
        message.createdAt = new Date(message.createdAt).getTime();
        message.content = this.handleContent(message.content);
        observer.next(message);
      });
    });
  }
  sendMessage(roomId: string, content: string): void {
    this.socket.emit('chat.send-message', { room: roomId, content: content });
  }
  selectParticipant(participant: any): Observable<any> {
    this.socket.emit('chat.select-participant', participant);
    return new Observable((observer) => {
      this.socket.on('chat.select-participant', (room: any) => {
        // console.log('select-participant', room);
        let participants = room.participants.filter((p: any) => p.id !== this.sharedService.user.id);
        if (!room?.data?.name) {
          room.data.name = participants.map((p: any) => p.profile.name).splice(0, 3).join(', ');
        }
        observer.next(room);
      });
    });
  }
  addMember(room: any, participants: any): Observable<any> {
    this.socket.emit('chat.add-members', room, participants);
    return new Observable((observer) => {
      this.socket.on('chat.add-members', (room: any, participants: any) => {
        observer.next({ room, participants });
      });
    });
  }
  removeMember(room: any, participant: any): Observable<any> {
    this.socket.emit('chat.remove-members', room, participant);
    return new Observable((observer) => {
      this.socket.on('chat.remove-members', (room: any, participant: any) => {
        observer.next({ room, participant });
      });
    });
  }
  getMessages(room: any, page = 1): Observable<any> {
    this.store.currentRoom = room;
    this.socket.emit('chat.get-messages', room, page);
    return new Observable((observer) => {
      const handler = (messages: any) => {
        const processedMessages = messages.data.map((m: any) => ({
          ...m,
          content: this.handleContent(m.content),
          user: this.getParticipant(m.user),
          createdAt: new Date(m.createdAt).getTime(),
        }));

        observer.next(processedMessages);
        this.socket.off('chat.get-messages', handler); // Hủy lắng nghe ngay sau khi nhận dữ liệu
      };

      this.socket.on('chat.get-messages', handler);
      // this.socket.on('chat.get-messages', (messages: any) => {
      //   messages = messages.data.map((m: any) => {
      //     return {
      //       ...m,
      //       content: this.handleContent(m.content),
      //       user: this.getParticipant(m.user),
      //       createdAt: new Date(m.createdAt).getTime(),
      //     };
      //   });
      //   observer.next(messages);
      // });
    });
  }
  handleContent(content: string): string {
    return content.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
  getRooms(): Observable<any> {
    this.socket.emit('chat.get-rooms', {});
    return new Observable((observer) => {
      this.socket.on('chat.get-rooms', (rooms: any) => {
        rooms.map((r: any) => r.participants).flat().forEach((p: any) => {
          if (!this.store.participants[p.id]) {
            this.store.participants[p.id] = p;
          }
        })
        rooms = rooms.map((r: any) => {
          let participants = r.participants.filter((p: any) => p.id !== this.sharedService.user.id);
          r.data.name = r?.data?.name || participants.map((p: any) => this.getParticipant(p).profile.name).splice(0, 3).join(', ');
          // r.data.avatar = r?.data?.avatar || participant.profile.avatar;
          return r;
        });
        observer.next(rooms);
      });
    });
  }
  getParticipant(id: any): any {
    id = typeof id === 'object' ? id.id : id;
    let user = this.store.participants[id] || { id: id, profile: { name: 'Unknown', avatar: '' } };
    if (user.deletedAt != null) {
      user.profile.name = this.translate.instant('chat_deleted_account');
    }
    // console.log('getParticipant', id, user);
    return user;
  }
  searchUser(query: string): Observable<any> {
    return new Observable((observer) => {
      this.socket.emit('chat.search-user', query);
      this.socket.on('chat.search-user', (data: any) => {
        observer.next(data);
      });
    });
  }
  getSocketInstance(): Socket {
    return this.socket;
  }

}
